export interface ApplicationReference {
  applicationReference: string;
}

export interface Application {
  applicationReference: string;
  departmentReference?: string;
  name?: string;
  created?: string;
  updated?: string;
  status: number;
  partyId?: number;
  customerId?: number;
  inviteDetail?: InviteDetail;
  isJoint?: boolean;
  progress?: number;
  isExpired?: boolean;
  idvCheckCompleted?: boolean;
  shareWorkReportData?: boolean;
  shareOpenBankingData?: boolean;
  shareIdDocData?: boolean;
  accountRequirementCheckStatus?: string;
  applicantReference?: string;
}

export interface JointApplication {
  created: string;
  applicationReference: string;
  departmentReference: string;
  status: number;
  partyName: string;
}

export interface InviteDetail {
  inviteSent: string;
  expirationDate: string;
  reminderCount: number;
}

export interface ApplicationResponse {
  totalApplications: number;
  records: ApplicationRecord[];
}

export interface ApplicationRecord {
  status: string;
  isJoint: boolean;
  applications: Application[];
}

export interface CreateApplication {
  departmentReference: string;
  journeyId: number;
  customerId: number;
}

export interface ApplicationEvent {
  id: string;
  name: string;
  description: string;
  timestamp: string;
}

export class ApplicationEventResponse {
  applicationReference: string;
  departmentReference: string;
  events: ApplicationEvent[];
}

export class ApplicationSummary {
  score: number;
  status: string;
  filter: string;
  progress: ProgressValue;
}

export class ProgressValue {
  value: number;
  backgroundColor?: string;
}

export class JointApplicationPayload {
  departmentReference: string;
  items: CustomerItems[];
  journeyId: number;
}

export interface CustomerItems {
  customerId: number;
  applicantReference: string;
}

export interface ApplicationStatuses {
  totalApplications: number;
  statuses: Statuses[];
}

export interface Statuses {
  status: string;
  count: number;
}

export interface ApplicationsRequestBody {
  search: string;
  offset: number;
  limit: number;
  status: string;
  improved: boolean;
  allowEmptyCollectionResponse: boolean;
}

export interface ApplicationsSearchRequestBody {
  searchType: SearchType;
  applicationReferenceSearch: string;
  nameSearch: string;
  status: string;
  offset?: number;
  limit?: number;
  allowEmptyCollectionResponse: boolean;
}

export enum SearchType {
  All = 'all',
  Last3Months = 'last3Months',
  Unknown = '',
}
